import { EditOutlined } from "@ant-design/icons";
import { Col, Row, Typography } from "antd";
import { SHIPPING_PROVIDER_TYPE, SHIPPING_TYPE } from "features/Cart/constants";
import { EDITABLE_SHIPPING_STATUSES, PAYMENT_STATUS, SHIPPING_VERSION } from "features/Order/constants";
import { useOrderPermissions } from "hooks/order";
import { t } from "i18next";
import { useState } from "react";
import { formatCurrency } from "utils/helperFuncs";
import ModalChangeShippingMethod from "../ModalChangeShippingMethod";

const DeliveryMethod = ({ dataInfoAgent, order, onRefetch }) => {
  const { shippingType, shippingTypeName, shippingConfiguration, shippingVersion } = dataInfoAgent;
  const [visibleChangeShippingMethod, setVisibleChangeShippingMethod] = useState(false);
  const { canUpdateShippingMethod } = useOrderPermissions();

  // Entry point sửa PTVC/ĐVVC.
  const canEditShipping =
    canUpdateShippingMethod &&
    EDITABLE_SHIPPING_STATUSES.includes(order?.status) &&
    order?.paymentStatus !== PAYMENT_STATUS.PAID;

  // Label bên trái set cứng px (đủ chứa "Phương thức giao hàng" — label dài nhất), bên phải flex
  // hết phần còn lại — thay cho Col span cố định theo lưới 24 cột (dễ bị cắt/lệch khi tên ĐVVC/PTVC
  // dài).
  const LABEL_WIDTH = 170;

  const renderInfoRow = (label, value) => (
    <Col span={24}>
      <Row wrap={false} align="middle">
        <Col style={{ width: LABEL_WIDTH, flexShrink: 0 }}>
          <Typography.Text strong>{label}</Typography.Text>
        </Col>
        <Col flex="auto">
          <Typography.Text strong style={{ color: "#052987" }}>
            {value}
          </Typography.Text>
        </Col>
      </Row>
    </Col>
  );

  const renderInfoDeliveryMethod = {
    [`${SHIPPING_TYPE.BUS}`]: (
      <>
        {renderInfoRow(`${t("order.orderDetail.busName")}:`, shippingConfiguration?.busConfig?.busName)}
        {renderInfoRow(`${t("order.orderDetail.busPhone")}:`, shippingConfiguration?.busConfig?.telephone)}
        {renderInfoRow(`${t("order.orderDetail.busStation")}:`, shippingConfiguration?.busConfig?.busStation)}
      </>
    ),
    [`${SHIPPING_TYPE.DELIVER_3PARTY}`]: renderInfoRow(
      `${t("order.orderDetail.ĐVVC")}:`,
      shippingVersion === SHIPPING_VERSION?.V2
        ? shippingConfiguration?.deliver3PartyConfig?.provider?.name
          ? `${SHIPPING_PROVIDER_TYPE[shippingConfiguration?.deliver3PartyConfig?.carrierMethod]} - ${
              shippingConfiguration?.deliver3PartyConfig?.provider?.name
            }`
          : SHIPPING_PROVIDER_TYPE[shippingConfiguration?.deliver3PartyConfig?.carrierMethod]
        : shippingConfiguration?.deliver3PartyConfig?.provider?.name
    ),
    [`${SHIPPING_TYPE.DELIVER_3PARTY_INSTANT}`]: renderInfoRow(
      `${t("order.orderDetail.ĐVVC")}:`,
      shippingVersion === SHIPPING_VERSION?.V2
        ? shippingConfiguration?.deliver3PartyConfig?.provider?.name
          ? `${SHIPPING_PROVIDER_TYPE[shippingConfiguration?.deliver3PartyConfig?.carrierMethod]} - ${
              shippingConfiguration?.deliver3PartyConfig?.provider?.name
            }`
          : SHIPPING_PROVIDER_TYPE[shippingConfiguration?.deliver3PartyConfig?.carrierMethod]
        : shippingConfiguration?.deliver3PartyConfig?.provider?.name
    ),
    [`${SHIPPING_TYPE.PICK_UP_COUNTER}`]: null,
    [`${SHIPPING_TYPE.URBAN_COD}`]: renderInfoRow(
      `${t("order.orderDetail.shippingFee")}:`,
      formatCurrency(shippingConfiguration?.urbanConfig?.fee)
    ),
  };

  return (
    <>
      <Col span={24}>
        <Row wrap={false} align="middle">
          <Col style={{ width: LABEL_WIDTH, flexShrink: 0 }}>
            <Typography.Text strong>{t("cart.deliveryMethodLabel")}</Typography.Text>
          </Col>
          <Col flex="auto">
            {/* Tên PTVC lấy thẳng từ BE (`order.shippingTypeName`) — đổi tên trong DB là UI đổi theo,
                FE không map cứng theo enum `shippingType` nữa. BE chưa trả thì hiện "--". */}
            <Typography.Text strong style={{ color: "#052987" }}>
              {shippingTypeName || "--"}
            </Typography.Text>
            {canEditShipping && (
              <EditOutlined
                onClick={() => setVisibleChangeShippingMethod(true)}
                style={{ color: "#2563EB", fontSize: 14, marginLeft: 8, cursor: "pointer" }}
              />
            )}
          </Col>
        </Row>
      </Col>
      {renderInfoDeliveryMethod[shippingType]}
      <ModalChangeShippingMethod
        visible={visibleChangeShippingMethod}
        onClose={() => setVisibleChangeShippingMethod(false)}
        order={order}
        onRefetch={onRefetch}
      />
    </>
  );
};

export default DeliveryMethod;
